import React from 'react';
import { BsFillCameraVideoFill } from '@react-icons/all-files/bs/BsFillCameraVideoFill';

import { decorateComponent } from '../../documentComponents';
import { Lottie } from './Lottie';
import { LottieInspector } from './LottieInspector';

export default decorateComponent(Lottie, 'block', {
  id: 'lottie',
  label: '로티',
  renderIcon: () => <BsFillCameraVideoFill />,
  renderInspector: LottieInspector,
  allowedChildren: [],
});
